import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const CreateContainer = styled('div')({
  maxWidth: 1000,
  margin: '0 auto',
});

export const CreateFlex = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
  },
}));

export const CreateTitle = styled('div')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 13,
  marginBottom: theme.spacing(2),
  fontWeight: 'bold',
}));

export const CreateAlertContainer = styled('div')({
  width: 500,
  margin: '10px auto',
});

export const CreateListContainer = styled('div')(({ theme }) => ({
  width: '50%',
  boxSizing: 'border-box',
  padding: theme.spacing(4),
  [theme.breakpoints.down('lg')]: {
    width: '100%',
  },
}));

export const CreatePermsContainer = styled('div')(({ theme }) => ({
  width: '50%',
  boxSizing: 'border-box',
  padding: theme.spacing(4),
  paddingLeft: theme.spacing(8),
  [theme.breakpoints.down('lg')]: {
    width: '100%',
    marginBottom: '80px',
  },
}));

export const CreateAccessContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const CreateButtonContainer = styled('div')(({ theme }) => ({
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
  width: '100%',
  maxWidth: 1000,
  margin: '0 auto',
  padding: theme.spacing(2),
}));

export const CreateButton = styled(Button, {
  shouldForwardProp: (p) => p !== 'submitVariant',
})(({ theme, submitVariant }) => ({
  backgroundColor: submitVariant ? theme.palette.secondary.main : theme.palette.grey[700],
  marginRight: theme.spacing(2),
}));
